module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-ira001.86e57248.png";